<app-chart-wrapper [title]="'Clients'">
    <app-chart-filter filter></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>